import axios from 'axios'

//关掉spin

class Service {
	constructor() {
		this.baseURL = '';
		this.timeout = 10000;
	}


	interceptors(instance) {
		this.requestInterceptors(instance)
		this.reponseInterceptors(instance)
	}

	requestInterceptors(instance) {
		instance.interceptors.request.use((config) => {
			config.headers['accessToken'] = localStorage.getItem('accessToken') || '';
			return config
		}, (error) => {
			return Promise.reject(error)
		})
	}

	reponseInterceptors(instance) {
		instance.interceptors.response.use((response) => {
			const { data } = response
			return data
		}, (error) => {
			return Promise.reject(error)
		})
	}

	request(options) {
		const config = {
			...options,
			baseURL: this.baseURL,
			timeout: this.timeout
		}
		const instance = axios.create(config)
		this.interceptors(instance)
		return instance
	}
}

export default new Service().request();
